import { z } from "zod";
import { readMessageBodySchema, staffMessageBodySchema } from "./chat.js";
export const SCHEDULE_MAX_DAYS_AHEAD = 90;
export const scheduledMessageStateSchema = z.enum(["scheduled", "held", "sent", "cancelled"]);
export const ifNoReplySchema = z.enum(["none", "remind", "nudge"]);
export const scheduledMessageSchema = z.object({
    id: z.string(),
    authorId: z.string(),
    authorName: z.string().nullable(),
    body: readMessageBodySchema,
    sendAt: z.string(),
    state: scheduledMessageStateSchema,
    heldAt: z.string().nullable(),
    ifNoReply: ifNoReplySchema,
    replyByDays: z.number().int().nullable(),
    nudgeText: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const scheduleMessageRequestSchema = z
    .object({
    body: staffMessageBodySchema,
    sendAt: z.string().datetime({ offset: true }),
    ifNoReply: ifNoReplySchema,
    replyByDays: z.number().int().min(1).max(60).optional(),
    nudgeText: z.string().min(1).max(1000).optional(),
})
    .superRefine((req, ctx) => {
    if ((req.ifNoReply === "none") !== (req.replyByDays === undefined)) {
        ctx.addIssue({
            code: "custom",
            path: ["replyByDays"],
            message: "replyByDays is required unless ifNoReply is none",
        });
    }
    if ((req.ifNoReply === "nudge") !== (req.nudgeText !== undefined)) {
        ctx.addIssue({
            code: "custom",
            path: ["nudgeText"],
            message: "nudgeText is required when ifNoReply is nudge, and only then",
        });
    }
});
export const scheduledMessageListResponseSchema = z.object({
    messages: z.array(scheduledMessageSchema),
});
